import { render, staticRenderFns } from "./agricole.vue?vue&type=template&id=473d9770&scoped=true"
import script from "./agricole.vue?vue&type=script&lang=js"
export * from "./agricole.vue?vue&type=script&lang=js"
import style0 from "./agricole.vue?vue&type=style&index=0&id=473d9770&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "473d9770",
  null
  
)

export default component.exports